"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_tracking_core_1 = require("@al/event-tracking-core");
exports.default = {
    init: event_tracking_core_1.noop,
    track: event_tracking_core_1.noop,
    use: event_tracking_core_1.noop,
    quick: event_tracking_core_1.noop,
    identify: event_tracking_core_1.noop,
    login: event_tracking_core_1.noop,
    logout: event_tracking_core_1.noop,
    setOnceProfile: event_tracking_core_1.noop,
    setProfile: event_tracking_core_1.noop,
    appendProfile: event_tracking_core_1.noop,
    incrementProfile: event_tracking_core_1.noop,
    deleteProfile: event_tracking_core_1.noop,
    unsetProfile: event_tracking_core_1.noop,
    registerPage: event_tracking_core_1.noop,
    getPresetProperties: event_tracking_core_1.noop,
};
